import {
  Control,
  RegisterOptions,
  UseFormSetError,
  UseFormWatch,
} from "react-hook-form";

export interface FormInputProps {
  name: string;
  control: Control<any, any>;
  label?: string;
  setValue?: any;
  rules?: RegisterOptions;
  required?: boolean;
  helperText?: string;
  setError: UseFormSetError<any>;
  watch?: UseFormWatch<any>;
  hasUpload?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
}

export interface FormCustomerAutoSearchProps {
  multiple?: boolean;
  selectedItemIds?: string[];
}

export enum FileType {
  "image" = "image",
  "video" = "video",
  "mp3" = "mp3",
  "file" = "file",
  "pdf" = "pdf",
  "qrcode" = "qrcode",
  "text" = "text",
  "avatar" = "avatar",
}
